import React, {FunctionComponent} from 'react';
import {useNavigate} from 'react-router-dom';
import {route} from 'b302-frontend-library';

import Response from '../../../../networking/models/Response';
import University from '../../../../networking/models/University';
import HanPagination from '../../../utils/HanPagination';
import ResponseCard from '../../partials/university/ResponseCard';
import {toast} from 'react-toastify';
import {ResponseIndexResponse} from '../../../../networking/responses/Response';
import {useResponseSaveMutation} from '../../../query/Response/Mutation';

interface Props {
    university: University;
    responses: ResponseIndexResponse;

    onPageChange: (page: number) => void;
}

const ResponsesContent: FunctionComponent<Props> = (props) => {
    const navigate = useNavigate();

    const responseSaveMutation = useResponseSaveMutation(props.university.id!);

    const onResponseClick = (response: Response) => {
        navigate(route('admin-response-detail',{ id: props.university.id, responseId: response.id }));
    };

    const onResponseChange = (response: Response) => {
        toast.promise(responseSaveMutation.mutateAsync(response), {
            pending: `Saving response ${response.id}`,
            success: `Saved response ${response.id}`,
            error: `Error saving response ${response.id}`,
        });
    };

    return (
        <>
            <h1>Responses ({ props.responses.total }) <span className={'admin-responses-page__university'}>{ props.university.name }</span></h1>

            <div className={'admin-responses-page__response-list'}>
                { props.responses.data.map(response => (
                    <ResponseCard
                        response={response}
                        onClick={onResponseClick}
                        onResponseChange={onResponseChange}
                        key={response.id} />
                )) }
            </div>

            <HanPagination
                pageCount={props.responses.lastPage}
                currentPage={props.responses.currentPage}
                onPageChange={props.onPageChange}
                pageRangeDisplayed={20}/>
        </>
    );
};

export default ResponsesContent;
